import { theme } from '../themes/theme';
import { BookingStatus } from '../types';
export function translateStatusToColorBasedOnTodayDate(status, endDate) {
    const isUpcoming = new Date().setHours(0, 0, 0, 0) < new Date(endDate).setHours(0, 0, 0, 0);
    return translateStatusToColor(status, isUpcoming);
}
export function translateStatusToColor(status, upcoming = false) {
    let color;
    switch (status) {
        case BookingStatus.Pending:
            color = theme.palette.pending.main;
            break;
        case BookingStatus.Approved:
            color = upcoming
                ? theme.palette.approvedFuture.main
                : theme.palette.approvedTaken.main;
            break;
        case BookingStatus.Rejected:
            color = theme.palette.rejected.main;
            break;
        case BookingStatus.Cancelled:
            color = theme.palette.cancelled.main;
            break;
        case BookingStatus.PendingCancellation:
            color = theme.palette.pendingCancellation.main;
            break;
        case BookingStatus.Withdrawn:
            color = theme.palette.withdrawn.main;
            break;
        default:
            color = '';
            break;
    }
    return color;
}
export function translateStatusToClassName(status, upcoming = false, calendar = false) {
    let className;
    const prefix = calendar ? 'calendar_date' : 'day';
    switch (status) {
        case BookingStatus.Pending:
        case BookingStatus.PendingCancellation:
            className = prefix + '_pending';
            break;
        case BookingStatus.Approved:
            className = prefix + (upcoming ? '_approved_future' : '_approved_taken');
            break;
        case BookingStatus.Rejected:
            className = prefix + '_rejected';
            break;
        case BookingStatus.Cancelled:
            className = prefix + '_cancelled';
            break;
        case BookingStatus.Withdrawn:
            className = prefix + '_withdrawn';
            break;
        default:
            throw new Error(`BookingStatus not implemented ${status}`);
    }
    return className;
}
